import { useQuery } from '@tanstack/react-query';
import { getShipmentsLedgers } from 'utils/ShipmentWebAPIUtils';
export function useShipmentLedgers(jobIds, ledgerType, options = {}) {
    var _a, _b;
    return useQuery({
        queryKey: ['shipment-ledgers', ledgerType, jobIds],
        queryFn: async () => {
            var _a;
            const result = await getShipmentsLedgers(jobIds, ledgerType);
            return (_a = result.entity.items) !== null && _a !== void 0 ? _a : [];
        },
        enabled: (_a = options.enabled) !== null && _a !== void 0 ? _a : jobIds.length > 0,
        staleTime: (_b = options.staleTime) !== null && _b !== void 0 ? _b : 30000,
    });
}
